import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import React, { PropsWithChildren } from 'react'
import { useDispatch } from 'react-redux'

const drawerWidth = 240;

const RightDrawer: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    const dispatch = useDispatch();

    return (
        <Drawer
            variant='permanent'
            anchor='left'
            open={true}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                '.MuiDrawer-paper': {
                    backgroundColor: theme => theme.palette.grey[100],
                }
            }}
        >

            <Toolbar />
            {children}
        </Drawer >
    )
}

export default RightDrawer;
